<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import {OrdersPath} from "@/path";
import Missing_items from "@/views/pages/Dilfoods/Orders/missing_items";
import Complaints from "./complaints.vue";
/* Dashboard component */
export default {
  components: {
    Missing_items,
    Layout,
    PageHeader,
    Complaints
},
  data() {
    return {
      title: "Orders",
      items: [
        {
          text: "List",
        },
        {
          text: "orders",
          active: true,
        },
      ],
      orders : [],
      search : '',
      selectedOrder : {},
      base_url : process.env.VUE_APP_API_BACKEND_URL,
      cdn : process.env.VUE_APP_AWS_CDN,
      filter : [],
      currentPage : 1,
      order_type : '',
      fields : ["up_order_id","brand","restuarant","aggregator_id","aggregator","order_total","order_subtotal","order_created_at","actions"]
    };
  },
  watch : {
    currentPage(){
      this.getOrders();
    },
    order_type(){
      this.getOrders();
    },
    search(){
      this.getOrders();
    }
  },
  methods : {
    async getOrders(){
      try {
        let response = await axios.get(this.base_url + OrdersPath.GET_ORDERS,{
          params : {
            page : this.currentPage,
            order_status : this.order_type,
            search : this.search
          }
        });
        if(response.data.status == true){
          this.orders = response.data.data;
        }
      }catch (e){
        console.log(e);
      }
    },
    reload(){
      this.getOrders();
    },
    setEdit(d){
      this.selectedOrder = d;
      this.$bvModal.show('bv-add-order');
    },
    addMissingItems(v){
      this.selectedOrder = v;
      this.$bvModal.show('bv-missing-items');
    },
    addComplaints(v){
      this.selectedOrder = v;
      this.$bvModal.show('bv-complaints');
    }
  },
  mounted() {
    this.getOrders();
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-4">
              <div class="col-md-6">
                <b-modal id="bv-missing-items" size="xl" :title="'Mark Missing Items'" hide-footer>
                  <Missing_items @update="reload()" :selected_order="selectedOrder"></Missing_items>
                </b-modal>
                <b-modal id="bv-complaints" size="xl" :title="'Mark Complaints'" hide-footer>
                  <Complaints @update="reload()" :selected_order="selectedOrder"></Complaints>
                </b-modal>
              </div>
            </div>
            <b-tabs>
              <b-tab title="All" @click="order_type = ''"></b-tab>
              <b-tab title="Placed" @click="order_type = 'Placed'"></b-tab>
              <b-tab title="Acknowledged" @click="order_type = 'Acknowledged'"></b-tab>
              <b-tab title="Food Ready" @click="order_type = 'Food Ready'"></b-tab>
              <b-tab title="Dispatched" @click="order_type = 'Dispatched'"></b-tab>
              <b-tab title="Completed" @click="order_type = 'Completed'"></b-tab>
              <b-tab title="Cancelled" @click="order_type = 'Cancelled'"></b-tab>
            </b-tabs>
            <div class="table-responsive mb-0">
              <div class="pb-2 float-md-right w-sm-100 w-md-50 w-lg-100 w-25 mt-4">
                <b-row>
                  <b-col sm="12">
                    <b-input-group  size="sm">
                      <b-input-group-prepend is-text>
                        <i class="fa fa-search"></i>
                      </b-input-group-prepend>
                      <b-input size="sm" placeholder="Search" v-model="search"></b-input>
                    </b-input-group>
                  </b-col>
                </b-row>
              </div>
              <b-table
                  :key="orders.key"
                  :items="orders.data"
                  :fields="fields"
                  responsive="sm"
                  :filter="filter"
                  :current-page="currentPage"
              >
                <template v-slot:cell(restaurant)="row">
                  <p>{{row.item.restaurant.name}}</p>
                </template>
                <template v-slot:cell(brand)="row">
                  <p>{{row.item.brand.name}}</p>
                </template>
                <template v-slot:cell(actions)="row">
                  <b-button size="sm" v-if="order_type == 'Completed' || order_type == ''" @click="addMissingItems(row.item)" variant="primary">
                    Add Missing Items
                  </b-button>
                  <b-button size="sm" class="ml-4" v-if="order_type == 'Completed' || order_type == ''" @click="addComplaints(row.item)" variant="primary">
                    Add Complaints
                  </b-button>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination :key="orders.key" v-model="currentPage" :total-rows="orders.total" :per-page="orders.per_page"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>